<button
  mat-icon-button
  (click)="deleteConnector()"
  class="options-menu-btn"
  [hidden]="mode.inNodeConnectionMode"
>
  <svg-icon
    src="assets/svg/trashcan.svg"
    [svgStyle]="{
      'width.px': '16',
      'height.px': '16'
    }"
    svgClass="veryLightGrey"
  ></svg-icon>
</button>
